enum UserRole {
    VerifikatorErenMonev = 477,
    SuperAdminErenmonev = 488,
    PengelolaPusatErenmonev = 489
}

export default UserRole